import {
  Container,
  Button,
  Typography,
  Grid,
  Divider,
  Stack,
} from '@mui/material'
import { Campaign } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'

import LoadingCard from '../content/CampaignCardShimmer'
import ShowMoreButton from '../shared/ShowMoreButton'

import CampaignCard from './CampaignCard'
import { NormalizedPaidAdCampaign } from './PaidAdCampaigns/PaidAdCampaigns'

type CampaignResultsContainerProps = {
  resetFilters: () => void
  showMoreHandler: () => void
  results: (Campaign | NormalizedPaidAdCampaign)[]
  isLoading: boolean
  totalResults: number
  pageSize: number
  noResultsText?: string
}
const CampaignResultsContainer: React.FC<
  React.PropsWithChildren<CampaignResultsContainerProps>
> = ({
  showMoreHandler,
  resetFilters,
  children,
  results,
  isLoading,
  totalResults,
  pageSize,
  noResultsText,
}) => {
  return (
    <Container maxWidth="lg">
      <Grid container justifyContent="center" spacing={4}>
        {results &&
          results.map((campaign, index: number) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              key={`campaign-${campaign.id}`}
            >
              <CampaignCard {...campaign} index={index} dropLegacyStyles />
            </Grid>
          ))}
        {isLoading &&
          Array.from({ length: pageSize }).map((_, i) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              key={`loading-card-${String(i)}`}
            >
              <LoadingCard dropLegacyStyles />
            </Grid>
          ))}
      </Grid>
      <Divider sx={{ marginY: 4 }} />
      {!isLoading && totalResults === 0 && (
        <Stack justifyContent="center">
          <Typography variant="subtitle1" textAlign="center">
            {noResultsText || I18n.t('content.noCampaignsFound')}
          </Typography>
          <Button size="medium" onClick={resetFilters}>
            {I18n.t('shared.resetSearch')}
          </Button>
        </Stack>
      )}
      {!isLoading && results.length < totalResults && totalResults !== 0 && (
        <ShowMoreButton
          numberShown={(results && results.length) || 0}
          onClick={showMoreHandler}
          total={totalResults}
        />
      )}
      {children}
    </Container>
  )
}
export default CampaignResultsContainer
